import { observer } from 'mobx-react-lite'
import moment, { type Moment } from 'moment'
import { useState } from 'react'

import { dmsState } from '@/app/store'
import { type IPropgramDatesRange } from '@/app/types/dmsTypes'
import { Datepicker, Modal } from '@/shared'

import style from './DatesRangesProgramModal.module.scss'

interface IProps {
    ranges: IPropgramDatesRange[]
    onClose: () => void
    contractId: string
    polisId: string
    programId: string
}

export const DatesRangesProgramModal = observer((props: IProps) => {
    const { ranges, onClose, polisId, programId } = props

    const [rangesList, setRangesList] = useState<IPropgramDatesRange[]>(ranges)
    const [newRange, setNewRange] = useState<IPropgramDatesRange | null>(null)

    const onChangeStartedAt = (e: Moment) => {
        setNewRange((prev) => ({
            ...prev,
            startedAt: moment(e).format(),
            finishedAt: newRange ? newRange.finishedAt : ''
        }))
    }
    const onChangeFinishedAt = (e: Moment) => {
        setNewRange((prev) => ({
            ...prev,
            finishedAt: moment(e).format(),
            startedAt: newRange ? newRange.startedAt : ''
        }))
    }

    return (
        <Modal show onClose={onClose}>
            <div className={style.container}>
                <div className={style.blockHeader}>
                    <span>Диапазоны прикреплённой программы</span>
                </div>
                <div className={style.rangesWrapper}>
                    {newRange && (
                        <div className={style.rangeWrapper}>
                            <div className={style.range}>
                                <Datepicker
                                    value={moment(newRange.startedAt)}
                                    onChange={onChangeStartedAt}
                                    disabled={false}
                                />
                            </div>
                            <div className={style.range}>
                                <Datepicker
                                    value={moment(newRange.finishedAt)}
                                    onChange={onChangeFinishedAt}
                                    disabled={false}
                                />
                            </div>
                            <div className={style.remove} onClick={() => setNewRange(null)}>
                                <span>Отмена</span>
                            </div>
                        </div>
                    )}
                    {rangesList.map((range) => {
                        const { id, startedAt, finishedAt } = range
                        return (
                            <div key={id} className={style.rangeWrapper}>
                                <div className={style.range}>
                                    <Datepicker value={moment(startedAt).utc()} onChange={() => {}} disabled />
                                </div>
                                <div className={style.range}>
                                    <Datepicker value={moment(finishedAt).utc()} onChange={(e) => {}} disabled />
                                </div>
                                <div
                                    className={style.remove}
                                    onClick={() => {
                                        id &&
                                            dmsState.onRemoveProgramAttachRange(id, polisId, () => {
                                                setRangesList((prev) => prev.filter((range) => range.id !== id))
                                            })
                                    }}
                                >
                                    <span>Удалить</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className={style.actions}>
                    {!newRange && (
                        <button
                            className={style.btn}
                            onClick={() => setNewRange({ startedAt: moment().format(), finishedAt: moment().format() })}
                            disabled={false}
                        >
                            Добавить диапазон дат
                        </button>
                    )}
                    {newRange && (
                        <button
                            className={style.btn}
                            onClick={() => {
                                dmsState.onPostProgramAttachRange(
                                    {
                                        startedAt: moment(newRange.startedAt).format('YYYY-MM-DDT00:00:00+00:00'),
                                        finishedAt: moment(newRange.finishedAt).format('YYYY-MM-DDT23:59:59+00:00'),
                                        insuranceProgramId: programId,
                                        polisId
                                    },
                                    (incomingRange: IPropgramDatesRange) => {
                                        setRangesList((prev) => [incomingRange, ...prev])
                                        setNewRange(null)
                                    }
                                )
                            }}
                            disabled={false}
                        >
                            Сохранить
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    )
})
